import { useSelector } from 'react-redux';

/**
 * Employee permission check (non-POS).
 * ADMIN role always has permission; employees are checked against
 * their permission map (user.permission, with user.settings as legacy fallback).
 */
export default function useEmployeePermission() {
    const user = useSelector((state) => state.user?.data);

    const hasPermission = (permissionId) => {
        if (user?.role === 'ADMIN') {
            return true;
        }
        const permission = user?.permission ?? user?.settings ?? {};
        return Boolean(permission?.[permissionId]);
    };

    return { hasPermission };
}
